//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[0,"ConvertInputToReference",1,0],[0,"ConvertToReference",1,0],[0,"CreateConstraint",1,0],[1,"DirectionObject",0,"SelectNXObject",0],[0,"Section",0,"Section",0]],[[["parent","isStart","constraint"],"SetEndConstraint",{},3,0],[[],"UpdateDirectionObject",{},0,0],[[],"UpdateInputSection",{},0,0]],[]];
SPLM.SketchMirrorPatternBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchMirrorPatternBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;